import React from 'react';
import webapi from '../../../api/webapi';
import Spinner from 'react-bootstrap/Spinner'

import '../../css/header.css';
import '../../font/dana/fontiran.css';
import {Navbar, NavDropdown, Nav} from 'react-bootstrap';
import { Dropdown ,Button ,ButtonGroup } from 'react-bootstrap';

//import language_icon from '../../images/language2.png'
//import En from '../../images/En.png'
//import Fa from '../../images/Fa.pn
//import Fr from '../../images/Fr.png'

import '../../font/dana/style.css';
import '../../css/style.css';


class Header extends React.Component {
    state = {
                LoadingShow : false,
                LanguageInfo : [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]
            }

    async componentDidMount(){
        this.setState({LoadingShow:true});
        var LanguageInfo = '';

        if (this.props.LanguageInfo!=null)
        {
            LanguageInfo = this.props.LanguageInfo
            //console.log(LanguageInfo[0].Code);
        }else{
            LanguageInfo = [{Code:"Fa",Title:"فارسی",Direction:"rtl"}];
        }
        this.setState({LanguageInfo: LanguageInfo });

        const responseResultlanguages = await webapi.get('pages/languages/'+LanguageInfo[0].Code);
        //console.log(responseResultlanguages.data);
        this.setState({Languages:responseResultlanguages.data});

        const responseResult = await webapi.get('pages/menu/'+ LanguageInfo[0].Code );
        //console.log(responseResult.data);
        this.setState({MenuItems:responseResult.data});

        this.setState({LoadingShow:false});
    }

    render() {
        if  (this.state.LoadingShow===false){
            if (this.state.MenuItems) {
                if (this.state.MenuItems.length>0) {
                    return (
                        <div>
                            <div className="container-fluid" id="navbar_container_fluid"  style={{display: 'flex'}}>
                            <div className="container"> 
                                <div id="menu_container">
                                    <Navbar bg="light" expand="lg">
                                        {/* <Navbar.Brand href="/">پارسیگ دیتابیس</Navbar.Brand> */}
                                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                        <Navbar.Collapse id="basic-navbar-nav">
                                            <Nav className="mr-auto">
                                                {
                                                    this.state.MenuItems.map((MenuItem,j) =>{
                                                        return  (
                                                            (MenuItem.URL!=='.' && !MenuItem.SubMenu)
                                                            ?
                                                            <Nav.Link key={MenuItem.Code} href={MenuItem.URL+'?lang='+this.state.LanguageInfo[0].Code}>{MenuItem.Title}</Nav.Link>
                                                            :
                                                            <NavDropdown key={MenuItem.Code} title={MenuItem.Title}>
                                                                {
                                                                    (MenuItem.SubMenu)
                                                                    ?
                                                                    MenuItem.SubMenu.map((submenu,i) =>{
                                                                        return  (
                                                                                    (i===0)
                                                                                    ?
                                                                                    <div key={'i'+submenu.Code}>
                                                                                        <NavDropdown.Item key={'j'+submenu.Code} href={submenu.URL+'/?lang='+this.state.LanguageInfo[0].Code}>{submenu.Title}</NavDropdown.Item>
                                                                                    </div>
                                                                                    :
                                                                                    <div key={'k'+submenu.Code}>
                                                                                        <NavDropdown.Divider key={'k'+submenu.Code} />
                                                                                        <NavDropdown.Item key={'l'+submenu.Code} href={submenu.URL+'/?lang='+this.state.LanguageInfo[0].Code}>{submenu.Title}</NavDropdown.Item>
                                                                                    </div>
                                                                        )
                                                                    }
                                                                    )
                                                                    :
                                                                    null
                                                                }
                                                            </NavDropdown>
                                                        )                                                                
                                                    })                                                        
                                                } 
                                            </Nav>
                                        </Navbar.Collapse>
                                    </Navbar>
                                </div>
                                <div id="navbar_container" style={{Direction:'rtl'}}>
                                    <div className="nav-item dropdown">
                                        <div className="dropdown">
                                            <Dropdown as={ButtonGroup} style={{marginTop:'1px'}}>
                                                <Button variant="light" href={"?lang="+ this.state.Languages[0].Code}> 
                                                    <div className="lang_switch">
                                                        {this.state.Languages[0].Title}
                                                        {/* <img id="language_icon" alt="01" src={require('../../images/'+this.state.Languages[0].Code+'.png')} /> */}
                                                    </div>
                                                </Button>
                                                <Dropdown.Toggle split variant="light" id="dropdown-split-basic" />
                                                
                                                <Dropdown.Menu>
                                                {
                                                    this.state.Languages.map((LanguagesItem,j) =>{
                                                        return (
                                                            <Dropdown.Item key= {LanguagesItem.Code} href={"?lang="+ LanguagesItem.Code}>
                                                                <div id="lang_dropdoan">
                                                                            <span className='td_lang_tilte'>
                                                                                {LanguagesItem.Title}
                                                                            </span>
                                                                            {/* <span className='td_lang_flag'>
                                                                                <img id="language_icon" alt="01" src={require('../../images/'+LanguagesItem.Code+'.png')} />
                                                                            </span> */}
                                                                            </div>
                                                            </Dropdown.Item>
                                                        )
                                                    })
                                                }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            </div>
                        </div>
                    )
                }
                else
                {
                    return null
                }
            }
            else
            {
                return null
            }
        }
        else
        {
            return(
                <div style={{position: 'relative',display: 'flex',justifycontent: 'center',alignitems: 'center',width:'100%',height:'80px'}}>
                    <div style={{position: 'absolute',top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                        <Spinner
                        as="span"
                        variant="dark"
                        role="status"
                        aria-hidden="true"
                        animation="border"/>
                    </div>
                </div>
            )
        }
    }
 }

 export default Header;
